import { proxy } from "valtio";

export const salesContactState = proxy<{
  showAddSalesContact: boolean;
}>({
  showAddSalesContact: false,
});
